import { render, staticRenderFns } from "./MyNavBar.vue?vue&type=template&id=ef1e21ca&scoped=true"
import script from "./MyNavBar.vue?vue&type=script&lang=js"
export * from "./MyNavBar.vue?vue&type=script&lang=js"
import style0 from "./MyNavBar.vue?vue&type=style&index=0&id=ef1e21ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1e21ca",
  null
  
)

export default component.exports